import React from 'react'

export default function Formation() {
  return (
    <svg width="120" height="80" viewBox="0 0 120 80" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="2" y="2" width="116" height="76" rx="8" stroke="black" stroke-width="4"/>
    <mask id="path-2-inside-1_300_28" fill="white">
    <path d="M11 49C11 43.4772 15.4772 39 21 39H30C35.5228 39 40 43.4772 40 49V70H11V49Z"/>
    </mask>
    
    <path d="M7 49C7 41.268 13.268 35 21 35H30C37.732 35 44 41.268 44 49H36C36 45.6863 33.3137 43 30 43H21C17.6863 43 15 45.6863 15 49H7ZM40 70H11H40ZM7 70V49C7 41.268 13.268 35 21 35V43C17.6863 43 15 45.6863 15 49V70H7ZM30 35C37.732 35 44 41.268 44 49V70H36V49C36 45.6863 33.3137 43 30 43V35Z" fill="black" mask="url(#path-2-inside-1_300_28)"  className='formationbody'/>
    <circle cx="25" cy="27" r="9" stroke="black" stroke-width="4" className='formationbody'/>
    
    <rect x="56" y="12" width="53" height="56" rx="8" stroke="black" stroke-width="4" className='formationrec'/>
    </svg>
  )
}
